import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, Outlet } from 'react-router-dom';
import GPSQualityContainer from '../containers/gpsQualityReport';
import DetailViewContainer from '../containers/vehicleDetailContaner';
import RouteWrapper from '../../../../routing/RouterWrapper';
import { AuthenticationService } from '../../../../services/authorization';

const ReportsWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const authService = AuthenticationService.getInstance();

    if (location.pathname === '/reports') {
      navigate('gpsQuality');
      return;
    }

    const pathSegments = location.pathname.split('/');
    const reportType = pathSegments[2];
    if (reportType && !authService.getViewAccessForSubRoute(reportType)) {
      navigate('/reports/gpsQuality', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      <Route path="/" element={<WrapperWithOutlet />}>
        <Route path=":typeId" element={<RouteWrapper component={GPSQualityContainer} />} />
        <Route path=":typeId/:vehicleId" element={<RouteWrapper component={DetailViewContainer} />} />
      </Route>
    </Routes>
  );
};

const WrapperWithOutlet = () => {
  return <Outlet />;
};

export default ReportsWrapper;
